import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { SPACER, MEDIA_QUERIES } from 'radiance-ui/lib/constants';
import { LOCAL_COLORS } from 'styles/constants';

export const MainBox = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;
  align-items: center;
`;

export const FollowText = styled.div`
  color: ${({ theme }) => theme.COLORS.background};
  font-size: 14px;
  font-weight: ${({ theme }) => theme.TYPOGRAPHY.fontWeight.bold};
  margin-right: ${SPACER.xlarge};
  flex: 1 1 100%;
  margin-bottom: ${SPACER.large};
  ${MEDIA_QUERIES.mdUp} {
    flex: inherit;
    margin-bottom: 0;
  }
`;

export const IconsBox = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;
  max-width: 350px;
  align-items: center;
  gap: ${SPACER.xsmall};

  ${MEDIA_QUERIES.smUp} {
    gap: ${SPACER.small};
  }

  a {
    margin-right: ${SPACER.xlarge};
    &:hover {
      svg {
        color: ${({ theme }) => theme.COLORS.primaryTint3};
      }
    }
  }
`;

export const buttonStyles = css`
  row-gap: 0;
  margin: 0;
  max-width: 115px;
  width: fit-content !important;
  height: 40px;

  button {
    height: 40px;
    min-height: unset;
    padding: 0 ${SPACER.medium};
    width: fit-content;
    background-color: ${LOCAL_COLORS.surfaceBrandBolder};

    span {
      font-weight: 700;
      font-size: 14px;

      ${MEDIA_QUERIES.mdUp} {
        font-size: ${SPACER.medium};
      }
    }
  }
`;
